/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { headerHoldersConfig } from '../../config/header.config';
export interface IHeaderHoldersPluginMethods extends IPluginMethodMap {
  getHeaderHoldersSync(args?: any): any;
}

export class HeaderHoldersPlugin implements IAgentPlugin {
  readonly methods: IHeaderHoldersPluginMethods;

  constructor() {
    this.methods = {
      getHeaderHoldersSync: this.getHeaderHoldersSync.bind(this),
    };
  }

  getHeaderHoldersSync(args?: any) {
    return {
      header: headerHoldersConfig,
    };
  }
}
